import { createSelector } from 'reselect'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import getRouteAndMatchRouterSelect from 'modules/router/selectors/get-route-and-match/index.js'

const isStartWorkoutUrlRouterSelect = createSelector(
  getRouteAndMatchRouterSelect,
  (routeAndMatch) => {
    return routeAndMatch?.route?.path === ROUTE_PATH.START_WORKOUT
  }
)

export default isStartWorkoutUrlRouterSelect
